import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout1 from "@/pages/Layout1";
import LegalPage from "@/pages/LegalPage";
import {
  LEGAL_UPDATED,
  villkorSections,
  integritetSections,
  cookieSections,
} from "@/lib/legalContent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout1 />} />
          <Route
            path="/villkor"
            element={
              <LegalPage
                eyebrow="Juridiskt"
                title="Användarvillkor"
                updated={LEGAL_UPDATED}
                sections={villkorSections}
              />
            }
          />
          <Route
            path="/integritetspolicy"
            element={
              <LegalPage
                eyebrow="Juridiskt"
                title="Integritetspolicy"
                updated={LEGAL_UPDATED}
                sections={integritetSections}
              />
            }
          />
          <Route
            path="/cookies"
            element={
              <LegalPage
                eyebrow="Juridiskt"
                title="Cookiepolicy"
                updated={LEGAL_UPDATED}
                sections={cookieSections}
              />
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
